<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-token-name="IconArrowDown_24"
>
    <path
        d="M18.79 12.408a.814.814 0 0 0-1.02-.253l-4.52 2.246V5.75a1.25 1.25 0 0 0-2.5 0v8.651l-4.52-2.246a.813.813 0 0 0-.936 1.302l6.13 6.132a.813.813 0 0 0 1.15 0l6.13-6.132a.813.813 0 0 0 .087-1.049Z"
        fill="currentColor"
    />
</svg>
